import _ from 'underscore';
import { projectionGridScopeNavigator } from '@bingads-webui-campaign/projection-grid-scope-navigator';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { getPGridColumnResizePlugin } from '@bingads-webui-campaign/projection-grid-column-resize-helper';

const { noop } = _;

export const getAdditionalPlugins = ({
  gridName,
  permissions,
  preferenceService,
  crossPageSelectPlugin,
  toolbarPlugin,
  scope,
  i18n,
}) => () => _.compact([
  crossPageSelectPlugin,
  toolbarPlugin,
  {
    plugin: definePlugin => definePlugin('filterState', [], noop),
  }, {
    plugin: projectionGridScopeNavigator,
    config: scope,
  }, {
    plugin: placeholderPlugin,
    config: {
      container: '.all-settings-page .grid-noresult',
      text: i18n.getString('Grid_NoRecords'),
      filteredEmptyText: i18n.getString('Grid_NoFilteredRecords'),
    },
  },
  getPGridColumnResizePlugin({
    gridName,
    preferenceService,
    permissions,
  }),
]);
